// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio-mF668","input":"input-itbCr","label":"label-YmjCg","disabled":"disabled-YfUKZ","only_radio":"only_radio-Cxx0R"};